import { keysToCamelCase } from "@jti/fe-common";
import { mockApiShippingMethods } from "./shippingMethods.mock";
const availableShippingMethod = mockApiShippingMethods[0];
const selectedShippingMethod = {
    carrier_code: availableShippingMethod.carrier_code,
    method_code: availableShippingMethod.method_code,
    amount: availableShippingMethod.amount,
};
export const getShippingMethodsApiResponseMock = () => {
    return {
        cart: {
            shipping_addresses: [
                {
                    available_shipping_methods: mockApiShippingMethods,
                    selected_shipping_method: selectedShippingMethod,
                },
            ],
        },
    };
};
export const getShippingMethodsMock = {
    methods: keysToCamelCase(mockApiShippingMethods),
    methodSelected: keysToCamelCase(selectedShippingMethod),
};
//# sourceMappingURL=getShippingMethods.mock.js.map